import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitResult, setSubmitResult] = useState({
    success: false,
    error: false,
    message: ''
  });

  // Gestisce i cambiamenti nei campi del form
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id.replace('form', '').toLowerCase()]: value
    });
  };

  // Gestisce l'invio del form
  const handleSubmit = (e) => {
    e.preventDefault();
    
    try {
      // Prepara i parametri per l'email
      const subject = encodeURIComponent(formData.subject);
      const body = encodeURIComponent(
        `Nome: ${formData.name}\n` +
        `Email: ${formData.email}\n\n` +
        `${formData.message}`
      );
      
      // Apri il client email dell'utente con i campi precompilati
      window.location.href = `mailto:narao92@gmail.com?subject=${subject}&body=${body}`;
      
      // Resetta il form e mostra un messaggio di successo
      setFormData({ name: '', email: '', subject: '', message: '' });
      setSubmitResult({
        success: true,
        error: false,
        message: 'Si aprirà il tuo client email per completare l invio del messaggio.'
      });
    } catch (error) {
      console.error('Errore nell apertura del client email:', error);
      setSubmitResult({
        success: false,
        error: true,
        message: 'Si è verificato un errore. Assicurati di avere un client email configurato sul tuo dispositivo.'
      });
    }
  };

  return (
    <section id="contact-section" className="py-5 bg-light">
      <Container>
        <Row className="mb-5 text-center">
          <Col>
            <h2 className="display-4 fw-bold text-primary mb-3">Contattaci</h2>
            <div className="divider-custom">
              <div className="divider-custom-line"></div>
              <div className="divider-custom-icon">✦</div>
              <div className="divider-custom-line"></div>
            </div>
            <p className="lead text-muted mb-0">
              Hai domande o suggerimenti? Siamo qui per aiutarti!
            </p>
          </Col>
        </Row>
        
        <Row>
          <Col lg={5} className="mb-4 mb-lg-0">
            <Card className="border-0 shadow-sm h-100">
              <Card.Body className="p-4">
                <h3 className="h4 fw-bold mb-4">Informazioni di contatto</h3>
                <p className="text-muted mb-4">
                  Il nostro team di supporto è disponibile per rispondere a tutte le tue domande
                  e aiutarti a trovare gli eventi perfetti per te.
                </p>
                
                <div className="d-flex mb-3">
                  <div className="flex-shrink-0">
                    <Mail className="text-primary fs-4 me-3" />
                  </div>
                  <div>
                    <h4 className="h6 fw-bold mb-1">Email</h4>
                    <p className="text-muted mb-0">info@happyevents.com</p>
                  </div>
                </div>
                
                <div className="d-flex mb-3">
                  <div className="flex-shrink-0">
                    <Phone className="text-primary fs-4 me-3" />
                  </div>
                  <div>
                    <h4 className="h6 fw-bold mb-1">Telefono</h4>
                    <p className="text-muted mb-0">+39 349 4488250</p>
                  </div>
                </div>
                
                <div className="d-flex mb-3">
                  <div className="flex-shrink-0">
                    <MapPin className="text-primary fs-4 me-3" />
                  </div>
                  <div>
                    <h4 className="h6 fw-bold mb-1">Indirizzo</h4>
                    <p className="text-muted mb-0">
                      Vico Castelforte 11<br />
                      73057 Taviano (LE), Italia
                    </p>
                  </div>
                </div>
                
                <div className="d-flex">
                  <div className="flex-shrink-0">
                    <Clock className="text-primary fs-4 me-3" />
                  </div>
                  <div>
                    <h4 className="h6 fw-bold mb-1">Orari di supporto</h4>
                    <p className="text-muted mb-0">
                      Lunedì - Venerdì: 9:00 - 18:00<br />
                      Sabato: 10:00 - 14:00
                    </p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          
          <Col lg={7}>
            <Card className="border-0 shadow-sm">
              <Card.Body className="p-4">
                <h3 className="h4 fw-bold mb-4">Inviaci un messaggio</h3>
                
                {submitResult.success && (
                  <Alert variant="success" className="mb-4">
                    {submitResult.message}
                  </Alert>
                )}
                
                {submitResult.error && (
                  <Alert variant="danger" className="mb-4">
                    {submitResult.message}
                  </Alert>
                )}
                
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6} className="mb-3">
                      <Form.Group controlId="formName">
                        <Form.Label>Nome</Form.Label>
                        <Form.Control 
                          type="text" 
                          placeholder="Il tuo nome" 
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group controlId="formEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control 
                          type="email" 
                          placeholder="La tua email" 
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Form.Group className="mb-3" controlId="formSubject">
                    <Form.Label>Oggetto</Form.Label>
                    <Form.Control 
                      type="text" 
                      placeholder="Oggetto del messaggio" 
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                    />
                  </Form.Group>
                  
                  <Form.Group className="mb-4" controlId="formMessage">
                    <Form.Label>Messaggio</Form.Label>
                    <Form.Control 
                      as="textarea" 
                      rows={5} 
                      placeholder="Il tuo messaggio" 
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                    />
                  </Form.Group>
                  
                  <Button 
                    variant="primary" 
                    type="submit" 
                    size="lg"
                  >
                    Invia messaggio
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactSection;